import React, { FC } from 'react';
import PlayerNamesContext from './PlayerNamesContext';
import { IPlayerName } from '../../../../../shared/types/player.type';

interface Props {
  names: IPlayerName[];
  children: React.ReactNode;
}

const PlayerNamesProvider: FC<Props> = ({ names, children }) => {
  return (
    <PlayerNamesContext.Provider value={{ names }}>
      {children}
    </PlayerNamesContext.Provider>
  );
};

export default PlayerNamesProvider;
